export const getCheckoutRedirect = (userId, itemCount, orderCompleted, language) => {
    if (orderCompleted) return null;
    if (!(Number(userId) > 0)) return '/' + language + '/login';
    if (itemCount < 1) return '/' + language + '/';
    return null;
};
